var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{attrs:{"show":_vm.open,"width":_vm.width,"height":_vm.height},on:{"close":function($event){return _vm.$emit('close', !_vm.open)}}},[_c('iframe',{ref:"iframe",attrs:{"allow":"clipboard-write"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }